module.exports = __webpack_public_path__ + "static/media/image-card-8.40e87771.png";